import { create } from 'zustand'

import { Setters, State } from './types'
import { initialState } from './state'
import { GoogleMapsStructuredPlace } from '../../components/autocomplete/interfaces/googleMapsInterfaces'

export const useSearchEngineStore = create<State & Setters>((set) => ({
  ...initialState,
  setPropertyTypes: (value: string[]) =>
    set(() => ({
      propertyTypes: value
    })),
  setMaxBudget: (value: number) =>
    set(() => ({
      maxBudget: value
    })),
  setOperationType: (value: string) =>
    set(() => ({
      operationType: value
    })),
  setSharesCommission: (value: boolean) =>
    set(() => ({
      sharesCommission: value
    })),
  setLocation: (value: GoogleMapsStructuredPlace | undefined) =>
    set(() => ({
      location: value
    })),
  reset: () => set(initialState)
}))

